export default {
  _maxRetry: 1,
  _retry: true,
  get(key, parse) {
    let val;
    try {
      val = localStorage.getItem(key)
    } catch (e) {
      return undefined
    }
    if (val) {
      return parse ? JSON.parse(val) : val
    } else {
      return undefined
    }
  },
  set(key, val, retry) {
    retry = (typeof retry === "undefined") ? this._retry : retry;
    try {
      localStorage.setItem(key, val)
    } catch (e) {
      if (retry) {
        let max = this._maxRetry;
        while (max > 0) {
          max--;
          this.set(key, val, false)
        }
      }
    }
  },
  del(key) {
    try {
      localStorage.removeItem(key)
    } catch (e) {
      return undefined
    }
  }
}
